import { Component, SimpleChanges, ViewChild } from '@angular/core'
import { UntypedFormBuilder } from '@angular/forms'
import { AppSettingService, ReportsService } from '../../../../api/services'
import { ConfirmationService, MessageService } from 'primeng/api'
import {
  DataPageOfReport,
  KeyValue,
  ReportCategory,
  ReportParam,
  ReportParamDto,
  ReportRequest,
} from '../../../../api/models'
import { ActivatedRoute, NavigationEnd, Params, Router } from '@angular/router'
import { DatePipe } from '@angular/common'
import { ReportsViewParamsComponent } from '../reports-view-params/reports-view-params.component'
import * as moment from 'moment'
import { CareFinitySession } from '../../../services/CareFinitySession'
import { combineLatest, filter } from 'rxjs'

@Component({
  selector: 'app-reports-view-list',
  templateUrl: './reports-view-list.component.html',
  styleUrl: './reports-view-list.component.css',
})
export class ReportsViewListComponent {
  title: string = ''
  reportTypeList: Array<{ key; value }>
  cols: { field: string; header: string }[]
  report: DataPageOfReport
  showRecords: boolean = false
  reportCategoryID: number = -1
  reportCategoryName: string = ''
  reportType: any
  href: string
  visible: boolean
    popupDisplayReportsParams: boolean = false
    setPrintFlag: boolean = false;
  public dropDownDataType = {
    number: 0,
    string: 1,
    date: 2,
    boolean: 3,
    currency: 4,
    dateTime: 5,
    time: 6,
  }

  constructor(
    private fb: UntypedFormBuilder,
    private reportservice: ReportsService,
    private messageService: MessageService,
    private confirmation: ConfirmationService,
    private router: Router,
    private datePipe: DatePipe,
    private appSettingsService: AppSettingService,
    public activatedRoute: ActivatedRoute,
  ) {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        filter(() => this.router.url.includes('/category-reports-view')), // Filter based on URL path
      )
      .subscribe(() => {
        const state = this.router.getCurrentNavigation()?.extras.state
        this.reportCategoryID = state.report_CategoryId
        this.reportCategoryName = state.report_CategoryName
        this.LoadReport(this.reportCategoryID, -1)
      })
  }

  @ViewChild('reportsViewParams')
  reportsViewParamsComponent!: ReportsViewParamsComponent

  ngOnInit() {
    debugger
    //// Accessing the query parameters
    //this.activatedRoute.queryParamMap.subscribe(params => {
    //    this.reportCategoryID = +params.get('report_CategoryId');
    //    this.reportCategoryName = params.get('report_CategoryName');
    //    this.LoadReport(this.reportCategoryID, -1);
    //});

    this.cols = [
      { field: 'reportShortNote', header: 'Report' },
      { field: 'reportDisplayName', header: 'Description' },
      { field: 'patientFlag', header: 'Patient Report' },
      /*            { field: 'reportFileName', header: '' },*/
    ]

    this.reportTypeList = [
      { key: 'All Reports', value: -1 },
      { key: 'Patient Reports', value: 1 },
      { key: 'Non-Patient Reports', value: 0 },
    ]
      //this.title = this.reportCategoryName

     
    debugger
    this.LoadReport(this.reportCategoryID, -1)
  }

  //// In ReportsViewComponent
  //ngOnChanges(changes: SimpleChanges) {
  //    if (changes['reportCategoryID']) {
  //        this.LoadReport(this.reportCategoryID, -1);
  //    }
  //}

  LoadReport(reportCategoryId: number, reportType: any): void {
      this.title = this.reportCategoryName
    this.reportservice
      .reportsGetReportType({
        pageNumber: 1,
        pageSize: 10,
        reportType: reportType.value,
        reportCategoryId: reportCategoryId,
      })
      .subscribe((result) => {
        if (result.totalRecords > 0) {
          this.showRecords = true
        } else {
          this.showRecords = false
        }
          debugger;
        this.report = result
      })
  }

  searchonId(rType: number): void {
    //localStorage.setItem("reportcategory", this.reportType);
    this.LoadReport(this.reportCategoryID, rType)
  }

  paramView: ReportParamDto
  onViewReport_Click(rowData: any): void {
    this.reportservice
      .reportsGetReportParams({
        reportId: rowData.reportID,
      })
      .subscribe((resParamView) => {
        debugger
        var autoMapCount = 0
        if (
          resParamView.reportParamList &&
          resParamView.reportParamList.length > 0
        ) {
          var paramsWithRequired = resParamView.reportParamList.filter(
            (r) => r.isrequired == true,
          )
          autoMapCount = paramsWithRequired.length
        }

        if (resParamView.reportParamList.length <= 0) {
          //return this.openReport(resParamView, null);
          var reportReq: ReportRequest = {}
            reportReq.fileName = resParamView.report.reportFileName
            reportReq.reportDsnName = resParamView.report.reportDsnName
          reportReq.parameters = []
          return this.openReport(resParamView, reportReq)
        } else if (autoMapCount == resParamView.reportParamList.length) {
          var reportReq: ReportRequest = {}
          reportReq.fileName = resParamView.report.reportFileName
            reportReq.parameters = []
            reportReq.reportDsnName = resParamView.report.reportDsnName
          resParamView.reportParamList.forEach((item) => {
            reportReq.parameters.push({
              key: item.reportparamname,
              value: this.getMacroValues(item.picklistValues),
            })
          })

          return this.openReport(resParamView, reportReq)
        } else {
          debugger
          this.popupDisplayReportsParams = true
          this.reportsViewParamsComponent.title =
            resParamView?.report?.reportShortNote
          this.reportsViewParamsComponent.reportParamDto = resParamView
        }
      })
  }

  onReportViewParam_Click(reportParamDto: ReportParamDto): void {
    this.loadReport(reportParamDto)
  }

  /*
   **   This function which will loop through ReportParamList and check the values User has entered are valid or not,
   **   if values are not valid then it will show particular messages based on different DataTypes.
   */
  loadReport(reportParamDto: ReportParamDto): void {
    var valid: boolean = false
    var result: boolean = false
    var param: ReportRequest = {}
    param.parameters = []

    valid = true
    reportParamDto.reportParamList.forEach((item) => {
      debugger
      if (item.isrequired) {
        param.parameters.push({
          key: item.reportparamname,
          value: this.getMacroValues(item.picklistValues),
        })
      } else {
        if (this.isNullOrWhiteSpace(item.value, item.datatype)) {
          this.messageService.add({
            key: 'alertToast',
            severity: 'error',
            summary: `Error - "${item.reportparamname}"`,
            detail: `Value for param "${item.reportparamshortnote}" required `,
            life: 5000,
          })
          valid = false
        } else {
          switch (Number(item.datatype)) {
            case this.dropDownDataType.date:
              /*if (!moment.isDate(item.value)) {*/
              if (!this.isDate(item.value)) {
                this.messageService.add({
                  key: 'alertToast',
                  severity: 'error',
                  summary: `Error - "${item.reportparamname}"`,
                  detail: `Invalid value for param "${item.reportparamshortnote}" date value required `,
                  life: 5000,
                })
                valid = false
              } else if (
                /*else if (moment.isDate(item.mindate) && moment(item.value, 'YYYY-MM-DD').toDate() < moment(item.mindate, 'YYYY-MM-DD').toDate()) {*/
                this.isDate(item.mindate) &&
                moment(item.value, 'YYYY-MM-DD').toDate() <
                  moment(item.mindate, 'YYYY-MM-DD').toDate()
              ) {
                valid = false
                this.messageService.add({
                  key: 'alertToast',
                  severity: 'error',
                  summary: `Error - "${item.reportparamname}"`,
                  detail: `Invalid value for param "${item.reportparamshortnote}" a value >= "${item.mindate}" required `,
                  life: 5000,
                })
              } else if (
                this.isDate(item.maxdate) &&
                moment(item.value, 'YYYY-MM-DD').toDate() >
                  moment(item.maxdate, 'YYYY-MM-DD').toDate()
              ) {
                valid = false
                this.messageService.add({
                  key: 'alertToast',
                  severity: 'error',
                  summary: `Error - "${item.reportparamname}"`,
                  detail: `Invalid value for param "${item.reportparamshortnote}" a value <= "${item.maxdate}" required `,
                  life: 5000,
                })
              }
              break

            case this.dropDownDataType.dateTime:
              /*if (!moment.isDate(item.value)) {*/
              if (!this.isDate(item.value)) {
                this.messageService.add({
                  key: 'alertToast',
                  severity: 'error',
                  summary: `Error - "${item.reportparamname}"`,
                  detail: `Invalid value for param "${item.reportparamshortnote}" date value required `,
                  life: 5000,
                })
                valid = false
              } else {
                let startDateTime = new Date()
                let endDateTime = new Date()
                if (item.startDateTime.trim().length > 0) {
                  startDateTime = moment(item.startDateTime).toDate()
                }

                if (item.endDateTime.trim().length > 0) {
                  endDateTime = moment(item.endDateTime).toDate()
                }

                if (
                  item.startDateTime.trim().length > 0 &&
                  moment(item.value).toDate() < startDateTime
                ) {
                  valid = false
                  this.messageService.add({
                    key: 'alertToast',
                    severity: 'error',
                    summary: `Error - "${item.reportparamname}"`,
                    detail: `Invalid value for param "${item.reportparamshortnote}" a value >= "${item.startDateTime}" required `,
                    life: 5000,
                  })
                } else if (
                  item.endDateTime.trim().length > 0 &&
                  moment(item.value).toDate() > endDateTime
                ) {
                  valid = false
                  this.messageService.add({
                    key: 'alertToast',
                    severity: 'error',
                    summary: `Error - "${item.reportparamname}"`,
                    detail: `Invalid value for param "${item.reportparamshortnote}" a value <= "${item.endDateTime}" required `,
                    life: 5000,
                  })
                }
              }
              break

            case this.dropDownDataType.time:
              /*if (!moment(item.value).toDate().getTime()) {*/
              if (!this.isTime(item.value)) {
                this.messageService.add({
                  key: 'alertToast',
                  severity: 'error',
                  summary: `Error - "${item.reportparamname}"`,
                  detail: `Invalid value for param "${item.reportparamshortnote}" time value required `,
                  life: 5000,
                })
                valid = false
              } else {
                let startTime = new Date()
                let endTime = new Date()

                if (item.startTime.trim().length > 0) {
                  startTime = moment(item.startTime).toDate()
                }

                if (item.endTime.trim().length > 0) {
                  endTime = moment(item.endTime).toDate()
                }

                if (
                  item.startTime.trim().length > 0 &&
                  moment(item.value).toDate() < startTime
                ) {
                  valid = false
                  this.messageService.add({
                    key: 'alertToast',
                    severity: 'error',
                    summary: `Error - "${item.reportparamname}"`,
                    detail: `Invalid value for param "${item.reportparamshortnote}" a value >= "${item.startTime}" required `,
                    life: 5000,
                  })
                } else if (
                  item.endTime.trim().length > 0 &&
                  moment(item.value).toDate() > endTime
                ) {
                  valid = false
                  this.messageService.add({
                    key: 'alertToast',
                    severity: 'error',
                    summary: `Error - "${item.reportparamname}"`,
                    detail: `Invalid value for param "${item.reportparamshortnote}" a value <= "${item.startTime}" required `,
                    life: 5000,
                  })
                }
              }
              break

            case this.dropDownDataType.number:
              if (!this.isNumber(item.value)) {
                valid = false
                this.messageService.add({
                  key: 'alertToast',
                  severity: 'error',
                  summary: `Error - "${item.reportparamname}"`,
                  detail: `Invalid value for param "${item.reportparamshortnote}" numeric value required `,
                  life: 5000,
                })
              } else if (
                this.isNumber(item.minnumber) &&
                parseFloat(item.value) < parseFloat(item.minnumber)
              ) {
                valid = false
                this.messageService.add({
                  key: 'alertToast',
                  severity: 'error',
                  summary: `Error - "${item.reportparamname}"`,
                  detail: `Invalid value for param "${item.reportparamshortnote}" a value >= "${item.minnumber}" required `,
                  life: 5000,
                })
              } else if (
                this.isNumber(item.maxnumber) &&
                parseFloat(item.value) > parseFloat(item.maxnumber)
              ) {
                valid = false
                this.messageService.add({
                  key: 'alertToast',
                  severity: 'error',
                  summary: `Error - "${item.reportparamname}"`,
                  detail: `Invalid value for param "${item.reportparamshortnote}" a value <= "${item.maxnumber}" required `,
                  life: 5000,
                })
              }
              break

            case this.dropDownDataType.currency:
              if (!this.isNumber(item.value)) {
                valid = false
                this.messageService.add({
                  key: 'alertToast',
                  severity: 'error',
                  summary: `Error - "${item.reportparamname}"`,
                  detail: `Invalid value for param "${item.reportparamshortnote}" numeric value required `,
                  life: 5000,
                })
              } else if (
                this.isNumber(item.minCurrency) &&
                parseFloat(item.value) < parseFloat(item.minCurrency)
              ) {
                valid = false
                this.messageService.add({
                  key: 'alertToast',
                  severity: 'error',
                  summary: `Error - "${item.reportparamname}"`,
                  detail: `Invalid value for param "${item.reportparamshortnote}" a value >= "${item.minCurrency}" required `,
                  life: 5000,
                })
              } else if (
                this.isNumber(item.maxCurrency) &&
                parseFloat(item.value) > parseFloat(item.maxCurrency)
              ) {
                valid = false
                this.messageService.add({
                  key: 'alertToast',
                  severity: 'error',
                  summary: `Error - "${item.reportparamname}"`,
                  detail: `Invalid value for param "${item.reportparamshortnote}" a value <= "${item.maxCurrency}" required `,
                  life: 5000,
                })
              }
              break

            case this.dropDownDataType.string:
              if (
                this.isNumber(
                  item.maxstringlength ? item.maxstringlength.toString() : '',
                ) &&
                item.value.length >
                  parseFloat(
                    item.maxstringlength
                      ? item.maxstringlength.toString()
                      : '0',
                  ) &&
                parseFloat(
                  item.maxstringlength ? item.maxstringlength.toString() : '0',
                ) > 0
              ) {
                valid = false
                this.messageService.add({
                  key: 'alertToast',
                  severity: 'error',
                  summary: `Error - "${item.reportparamname}"`,
                  detail: `Invalid value for param "${item.reportparamshortnote}" a value <= "${item.maxstringlength}" required `,
                  life: 5000,
                })
              }
              break

            case this.dropDownDataType.boolean:
              break
          }
        }

        debugger
        if (valid) {
          if (Number(item.datatype) === this.dropDownDataType.date) {
            param.parameters.push({
              key: item.reportparamname,
              value: this.datePipe.transform(item.value, 'MM/dd/yyyy'),
            })
          } else if (Number(item.datatype) === this.dropDownDataType.dateTime) {
            param.parameters.push({
              key: item.reportparamname,
              value: this.datePipe.transform(item.value, 'MM/dd/yyyy HH:mm:ss'),
            })
          } else if (Number(item.datatype) === this.dropDownDataType.time) {
            param.parameters.push({
              key: item.reportparamname,
              value: this.datePipe.transform(item.value, 'MM/dd/yyyy HH:mm:ss'),
            })
          } else if (Number(item.datatype) === this.dropDownDataType.boolean) {
            param.parameters.push({
              key: item.reportparamname,
              value: item.value == 'true' ? '1' : '0',
            })
          } else {
            param.parameters.push({
              key: item.reportparamname,
              value: item.value.toString(),
            })
          }
        }
      }
    })

    if (valid) {
      var reportReq: ReportRequest = {}
      reportReq.fileName = reportParamDto.report.reportFileName
        reportReq.parameters = param.parameters
        reportReq.reportDsnName = reportParamDto.report.reportDsnName

      return this.openReport(reportParamDto, reportReq)
    } else {
      this.popupDisplayReportsParams = true
    }
  }

    openReport(paramView: ReportParamDto, request: ReportRequest): void

    {

       // alert("AAA");

       // alert(paramView);
    this.reportservice
      .reportsCreatePdf({
        body: request,
      })
      .subscribe((resReportDTO) => {
        this.reportservice
          .reportsGetReports({
            fn: resReportDTO.pdfFileName,
          })
          .subscribe((file) => {
            if (resReportDTO.flexPaper) {
              this.router.navigate(['show-pdf'], {
                relativeTo: this.activatedRoute,
                state: {
                    pdf: file,
                    showPrintButton: CareFinitySession?.practiceSettings?.enablePatientDemographicPrint && CareFinitySession?.user?.roles?.patientRecordsPrint,
                    enabledDocumentDownloads: CareFinitySession?.practiceSettings?.enableDocumentDownloads && CareFinitySession?.user?.roles?.enableDocumentDownloads,

                },
              })
            } else {
              const binaryData = [file]
              const downloadLink = document.createElement('a')
              downloadLink.href = window.URL.createObjectURL(
                new Blob(binaryData, { type: file.type }),
              )
              downloadLink.target = '_blank'
              downloadLink.setAttribute('inline', 'irfan')
              document.body.appendChild(downloadLink)
              downloadLink.click()
              document.body.removeChild(downloadLink) // Clean up
            }
          })
      })
  }

  isNullOrWhiteSpace(
    val: string | null | undefined,
    dataType: string,
  ): boolean {
    debugger
    var result = false
    if (Number(dataType) == this.dropDownDataType.date) {
      if (this.datePipe.transform(val, 'MM/dd/yyyy')) {
        result = false
      }
    } else if (Number(dataType) == this.dropDownDataType.dateTime) {
      if (this.datePipe.transform(val, 'MM/dd/yyyy HH:mm:ss')) {
        result = false
      }
    } else if (Number(dataType) == this.dropDownDataType.number) {
      return !val || val.length === 0
    } else if (Number(dataType) == this.dropDownDataType.time) {
      if (this.datePipe.transform(val, 'HH:mm:ss')) {
        result = false
      }
    } else if (Number(dataType) == this.dropDownDataType.boolean) {
      return !val || val.length === 0
    } else if (Number(dataType) == this.dropDownDataType.currency) {
      return !val || val.length === 0
    } else {
      return !val || val.trim().length === 0
    }
  }

  getMacroValues(mapp: string) {
    var result: string = ''
    switch (mapp.toUpperCase()) {
      case 'PERSONID': {
        result = sessionStorage.getItem('ptId')
        break
      }
      case 'PATIENTID': {
        result = sessionStorage.getItem('ptId')
        break
      }
      case 'EHRUSERID': {
        result = CareFinitySession.userPractices[0].defaultEHRUserId.toString()
        break
      }
      case 'USERID': {
        result = CareFinitySession.user.userID.toString()
        break
      }
      case 'ENTERPRISEID': {
        result = localStorage.getItem('EnterpriseID')
        break
      }
      case 'PRACTICEID': {
        result = localStorage.getItem('EmrPracticeId')
        break
      }
      case 'PROVIDERID': {
        result = localStorage.getItem('DefaultProviderId')
        break
      }
    }

    return result
  }

  isNullOrBlank(aValue: any, defaultValue: any): any {
    if (
      aValue === undefined ||
      aValue === null ||
      aValue === '' ||
      aValue === 'undefined'
    ) {
      return defaultValue
    }
    return aValue
  }

  isDate(aValue: string): boolean {
    try {
      if (!aValue) {
        return false
      }

      return moment(aValue).isValid()
    } catch {}
    return false
  }

  isTime(aValue: string): boolean {
    try {
      const dateString = '2011-10-09 ' + aValue
      moment(dateString, 'YYYY-MM-DD HH:mm:ss', true) // Ensure to adjust the format as per your requirement

      return true
    } catch {}
    return false
  }

  isNumber(aValue: string): boolean {
    try {
      Number.parseFloat(aValue)
      return true
    } catch {}
    return false
  }

  back() {
    window.history.back()
  }
}
